import { ActivatedRoute } from '@angular/router';
import {
    isEditPage
} from '@classifieds-sell/shared';

export const getSummarySectionLinkText = (
    route: ActivatedRoute
): string => {
    return isEditPage(route) ? 'View' : 'Edit';
};